import { c as _c } from "react/compiler-runtime";
import { Suspense } from "react";
import { FluxLayoutContent } from "./FluxLayoutContent";
import { Providers } from "@/providers";
import { UserModel } from "../../domain/models/User";
type Props = {
  currentUser: UserModel | null;
  children: React.ReactNode;
  locale?: string;
  isUserDataLoaded?: boolean;
};
export const FluxLayout = t0 => {
  const $ = _c(6);
  const {
    currentUser,
    children,
    locale
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== currentUser) {
    t1 = <div className="relative"><Suspense><FluxLayoutContent currentUser={currentUser}>{children}</FluxLayoutContent></Suspense></div>;
    $[0] = children;
    $[1] = currentUser;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== locale || $[4] !== t1) {
    t2 = <Providers locale={locale}>{t1}</Providers>;
    $[3] = locale;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};